import { ASIN_METRIC_TYPE } from '../../../constants/asin_metric_elements';
import { extractErrorMessage } from '../../../utilities';
import logger from '../../../utils/logging';
import MidwayClient from './midway_client';

let asinMetricsClient;

export function getAsinMetricsClient() {
  if (!asinMetricsClient) {
    asinMetricsClient = new AsinMetricsClient();
  }
  return asinMetricsClient
}

export class AsinMetricsClient extends MidwayClient{
  constructor(props) {
    super();
    this.props = props || {};
  }

  clientLoaded = (client) => {
    this.asinMetricsClient = client;

    if (this.props.hasOwnProperty('onReady')) {
      this.props.onReady();
    }
  };

  post = (endpoint, payload, callback, errorCallback) => {
    this.asinMetricsClient.post(endpoint, payload)
        .then((response) => callback(response))
        .catch((error) => {
          logger.error(extractErrorMessage(error), error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
  }

  postWithAsinTypeCallback = (endpoint, payload, type, callback, errorCallback) => {
    return this.asinMetricsClient.post(endpoint, payload)
        .then((response) => callback(response, type))
        .catch((error) => {
          logger.error(extractErrorMessage(error), error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
  }

  getGlMetrics = async (callback, errorCallback, payload) => {
    logger.info('Attempting to get glMetrics');
    try {
      const response = await this.asinMetricsClient.post('glMetric', payload);
      await callback(response);
    } catch (error) {
      logger.error(extractErrorMessage(error), error);
      if (errorCallback) {
        errorCallback(error);
      }
    }
  };

  getAsinMetrics = (callback, errorCallback, payload) => {
    logger.info('Attempting to get asinMetrics');
    this.post('asinMetric', payload, callback, errorCallback);
  }

  getNetVariancePerUnitHistogram = (callback, errorCallback, payload) => {
    logger.info('Attempting to get netVariancePerUnit histogram data');
    this.postWithAsinTypeCallback('histogram/netVariancePerUnit', payload, ASIN_METRIC_TYPE.NET_VAR_PER_UNIT, callback, errorCallback);
  };

  getAbsVariancePerUnitHistogram = (callback, errorCallback, payload) => {
    logger.info('Attempting to get absVariancePerUnit histogram data');
    this.postWithAsinTypeCallback('histogram/absVariancePerUnit', payload, ASIN_METRIC_TYPE.ABS_VAR_PER_UNIT, callback, errorCallback);
  };

  getHistogramAsin = (callback, errorCallback, payload, type) => {
    logger.info('Attempting to get histogram asin info');
    this.postWithAsinTypeCallback('histogramAsin', payload, type, callback, errorCallback);
  };
}



// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/asin_metrics_client.jsx